import { AppRedirectType } from 'types/app-redirect';
import { flattenQueryParam } from '@src/utils/request';
import { includesRequiredQueryParams } from '@src/utils/request';
import { investmentEntity } from '@store/modules/investment-entity';
import { RouteConfig } from 'vue-router';
import { user } from '@src/store/modules/user';

let entityExists = true;
const appRedirectRoutes: Array<RouteConfig> = [
	{
		path: '/app-redirect',
		name: 'app-redirect',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			const includesRequiredParams = includesRequiredQueryParams(['investmentEntityId', 'redirectPage'], to);
			if (includesRequiredParams) {
				const redirectPage = (flattenQueryParam(to.query.redirectPage) as AppRedirectType) ?? '';
				const investmentEntityId = flattenQueryParam(to.query.investmentEntityId) ?? '';

				try {
					if (investmentEntity.investmentEntityId !== investmentEntityId) {
						await user.updateSelectedEntity(investmentEntityId);
					}
				} catch (error) {
					entityExists = false;
					next({ name: 'forbidden' });
				}

				if (entityExists) {
					switch (redirectPage) {
						case 'SETTINGS':
							next({
								name: 'settings-account-information-redirect',
								replace: true
							});
							break;
						case 'DOCUMENTS':
							next({ name: 'account-documents', replace: true });
							break;
						default:
							next({ name: 'account-overview', replace: true });
							break;
					}
				}
			} else {
				next({ name: '404' });
			}
		}
	}
];

export default appRedirectRoutes;
